import React from "react";
import { Link } from "react-router-dom"; // Replace with standard <a> tags if React Router is not used
import "./Footer.css";

import {
    logo,
    curveimage,
    linkdinicon,
    facebookicon,
    instaicon,
    whatsappicon,
} from "../../assets/Exportimageicon";

const Footer = () => {
    return (
        <footer className="custom-footer">
            <div className="footercurve-wrapper common-flex-center">
                <img
                    src={curveimage}
                    alt="curve line"
                    className="curve-line-fluid"
                />
            </div>

            <div className="footer-content-container mt-4">
                {/* Footer Logo */}
                <div className="footer-logo-block">
                    <img
                        src={logo}
                        alt="Red3 Ascendor Logo"
                        className="footer-main-logo"
                    />
                </div>

                {/* Footer Navigation */}
                <nav className="footer-navigation">
                    <ul className="footer-links-list">
                        <li>
                            <a href="/home">Home</a>
                        </li>
                        <li>
                            <a href="/how-it-works">How it works</a>
                        </li>
                        <li>
                            <a href="/challenges">Explore Challenges</a>
                        </li>
                        <li>
                            <a href="/contact">Contact us</a>
                        </li>
                        <li>
                            <a href="/community">Community</a>
                        </li>
                    </ul>
                </nav>

                {/* Social Media Icons */}
                <div className="footer-social-media">
                    <button
                        type="button"
                        className="btn-socialmedia"
                        aria-label="Instagram"
                    >
                        <img src={instaicon} alt="Instagram" />
                    </button>

                    <button
                        type="button"
                        className="btn-socialmedia"
                        aria-label="WhatsApp"
                    >
                        <img src={whatsappicon} alt="WhatsApp" />
                    </button>

                    <button
                        type="button"
                        className="btn-socialmedia"
                        aria-label="LinkedIn"
                    >
                        <img src={linkdinicon} alt="LinkedIn" />
                    </button>

                    <button
                        type="button"
                        className="btn-socialmedia"
                        aria-label="Facebook"
                    >
                        <img src={facebookicon} alt="Facebook" />
                    </button>
                </div>

                <span style={{ display: "block" }}>
                    <hr className="bootom-line" />
                </span>

                {/* Footer Legal Links */}
                <div className="footer-legal-bar">
                    <div className="legal-left-links">
                        <a
                            href="/terms-and-conditions"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-legal-button"
                        >
                            Terms & Conditions
                        </a>
                    </div>

                    <div className="legal-left-links">
                        <a
                            href="/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-legal-button"
                        >
                            Privacy Policy
                        </a>
                    </div>

                    <div className="legal-right-copyright">
                        <p>© 2026 Copyright, All Right Reserved</p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;